export default __webpack_public_path__ + "static/Aeonik-LightItalic-b6becd62c18775ac9910cf09d2a993c0.otf";